/**
 * Firebase Configuration per HORECAPLAT
 * Gestisce Firebase Messaging per le notifiche push
 */
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyBOJLjLogv6T3x97a-TOMnj8XyCmLz6F9U",
  authDomain: "horecaplat.firebaseapp.com",
  projectId: "horecaplat",
  storageBucket: "horecaplat.firebasestorage.app",
  messagingSenderId: "579172535662",
  appId: "1:579172535662:web:8fb63e22c349108182057f",
  measurementId: "G-NLGQ5GVVZC"
};

const VAPID_KEY = "BLsM8wq7AWubxRnX33MMtFNJ3VGKmaY9uDNZHrESOCNHDSEKFIezSULnh50U_xo1gfwFcS8Fo5XVmK9xeTBfr3I";

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Messaging instance (will be null if not supported)
let messaging: ReturnType<typeof getMessaging> | null = null;

// Check if messaging is supported and initialize
export const initializeMessaging = async () => {
  try {
    const supported = await isSupported();
    if (supported) {
      messaging = getMessaging(app);
      return true;
    }
    console.log('Firebase Messaging not supported in this browser');
    return false;
  } catch (error) {
    console.error('Error initializing Firebase Messaging:', error);
    return false;
  }
};

// Request permission and get FCM token
export const requestNotificationPermission = async (): Promise<string | null> => {
  try {
    // Check if notifications are supported
    if (!('Notification' in window)) {
      console.log('Notifications not supported');
      return null;
    }

    // Request permission
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('Notification permission denied');
      return null;
    }

    // Initialize messaging if not already done
    if (!messaging) {
      const initialized = await initializeMessaging();
      if (!initialized || !messaging) {
        return null;
      }
    }

    // Register service worker
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    
    // Get FCM token
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration
    });

    if (token) {
      console.log('FCM Token:', token);
      return token;
    }

    console.log('No FCM token available');
    return null;
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
};

// Listen for foreground messages
export const onForegroundMessage = (callback: (payload: any) => void) => {
  if (!messaging) {
    console.warn('Messaging not initialized');
    return () => {};
  }

  return onMessage(messaging, (payload) => {
    console.log('Foreground message received:', payload);
    callback(payload);
  });
};

// Check if push notifications are supported
export const isPushSupported = async (): Promise<boolean> => {
  if (!('Notification' in window)) return false;
  if (!('serviceWorker' in navigator)) return false;
  
  try {
    return await isSupported();
  } catch {
    return false;
  }
};

// Get current permission status
export const getNotificationPermissionStatus = (): NotificationPermission | 'unsupported' => {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission;
};

export { app };
